import { EPromoType, IPromoInfo } from '../../../types/newbuilding/promoInfo';

export const getAuthorDescription = (promo: IPromoInfo, hasContacts: boolean): string | null => {
  if (promo.promoType === EPromoType.CianMortgage) {
    return null;
  }

  if (!hasContacts) {
    return null;
  }

  const agentLabel = promo.isFromBuilder ? 'застройщика' : 'представителя застройщика';

  return `Узнайте у ${agentLabel} подробности об акционном предложении`;
};
